// @ts-ignore
/* eslint-disable */

import React from 'react';
import cx from 'classnames';

const Eon = ({ className, ...props }: any) => (
  <svg className={cx(className)} width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <g filter="url(#filter0_ii_275_41618)">
  <rect width="36" height="36" rx="9.14062" fill="url(#paint0_linear_275_41618)"/>
  <g filter="url(#filter1_diii_275_41618)">
  <path d="M29.0668 14.3755L25.5602 16.4064C25.6668 16.9191 25.7234 17.4535 25.7234 17.9989C25.7234 20.7345 24.3007 23.1471 22.1559 24.5236C20.9551 25.2959 19.5303 25.7431 18.0011 25.7431C13.744 25.7431 10.2788 22.268 10.2788 17.9989C10.2788 15.9091 11.1098 14.009 12.4584 12.6151C13.8615 11.16 15.828 10.2547 18.0011 10.2547C18.2817 10.2547 18.5601 10.27 18.8342 10.3006L20.8899 6.73388L20.9008 6.69679C19.9741 6.45465 18.9995 6.32812 18.0011 6.32812C14.3771 6.32812 11.1359 7.99912 8.99973 10.6125C7.35086 12.626 6.36328 15.2001 6.36328 18.0011C6.36328 24.4364 11.584 29.6719 18.0011 29.6719C20.2416 29.6719 22.3364 29.0327 24.1137 27.9267C27.4288 25.8674 29.6367 22.1873 29.6367 18.0011C29.6367 16.7358 29.4344 15.5186 29.0624 14.3777L29.0668 14.3755Z" fill="url(#paint1_linear_275_41618)"/>
  <path d="M25.3253 12.7678C26.8871 12.7678 28.1532 11.4981 28.1532 9.93189C28.1532 8.36567 26.8871 7.096 25.3253 7.096C23.7635 7.096 22.4974 8.36567 22.4974 9.93189C22.4974 11.4981 23.7635 12.7678 25.3253 12.7678Z" fill="url(#paint2_linear_275_41618)"/>
  <path d="M18.001 6.38086C18.9738 6.38086 19.9235 6.50235 20.8281 6.7334L18.8047 10.2451C18.54 10.2169 18.2715 10.2021 18.001 10.2021C15.8131 10.2022 13.8334 11.1135 12.4209 12.5781C11.0631 13.9815 10.2256 15.8949 10.2256 17.999C10.2256 22.297 13.7148 25.7958 18.001 25.7959C19.5406 25.7959 20.9756 25.3459 22.1846 24.5684C24.3439 23.1826 25.7763 20.7532 25.7764 17.999C25.7764 17.463 25.7206 16.9376 25.6182 16.4326L29.0312 14.4561C29.3888 15.5739 29.584 16.7642 29.584 18.001C29.584 22.1682 27.3862 25.8318 24.0859 27.8818C22.3168 28.9828 20.2314 29.6191 18.001 29.6191C11.6132 29.6191 6.41602 24.4072 6.41602 18.001C6.41604 15.2126 7.39961 12.6499 9.04102 10.6455C11.1676 8.04405 14.3938 6.38089 18.001 6.38086ZM25.3252 7.14844C26.8576 7.14844 28.1005 8.39452 28.1006 9.93164C28.1006 11.4689 26.8577 12.7148 25.3252 12.7148C23.7927 12.7148 22.5498 11.4688 22.5498 9.93164C22.5499 8.39455 23.7928 7.14849 25.3252 7.14844Z" stroke="#828280" strokeWidth="0.105469"/>
  </g>
  </g>
  <defs>
  <filter id="filter0_ii_275_41618" x="0" y="-0.210938" width="36" height="36.4219" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
  <feFlood floodOpacity="0" result="BackgroundImageFix"/>
  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset dy="0.210938"/>
  <feGaussianBlur stdDeviation="0.175781"/>
  <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.27451 0 0 0 0 0.27451 0 0 0 0 0.27451 0 0 0 1 0"/>
  <feBlend mode="normal" in2="shape" result="effect1_innerShadow_275_41618"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset dy="-0.210938"/>
  <feGaussianBlur stdDeviation="0.175781"/>
  <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.27451 0 0 0 0 0.27451 0 0 0 0 0.27451 0 0 0 0.5 0"/>
  <feBlend mode="normal" in2="effect1_innerShadow_275_41618" result="effect2_innerShadow_275_41618"/>
  </filter>
  <filter id="filter1_diii_275_41618" x="0.949219" y="1.75781" width="34.1016" height="34.1719" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
  <feFlood floodOpacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset dy="0.84375"/>
  <feGaussianBlur stdDeviation="2.70703"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.626562 0 0 0 0 0.872245 0 0 0 0.3 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_275_41618"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_275_41618" result="shape"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset dy="0.351562"/>
  <feGaussianBlur stdDeviation="0.0527344"/>
  <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
  <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"/>
  <feBlend mode="normal" in2="shape" result="effect2_innerShadow_275_41618"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset dy="-0.351562"/>
  <feGaussianBlur stdDeviation="0.0527344"/>
  <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
  <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"/>
  <feBlend mode="normal" in2="effect2_innerShadow_275_41618" result="effect3_innerShadow_275_41618"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset dx="-0.105469"/>
  <feGaussianBlur stdDeviation="0.0878906"/>
  <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"/>
  <feBlend mode="normal" in2="effect3_innerShadow_275_41618" result="effect4_innerShadow_275_41618"/>
  </filter>
  <linearGradient id="paint0_linear_275_41618" x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">
  <stop stopColor="#252525"/>
  <stop offset="1" stopColor="#030303"/>
  </linearGradient>
  <linearGradient id="paint1_linear_275_41618" x1="18" y1="6.32812" x2="18" y2="29.6719" gradientUnits="userSpaceOnUse">
  <stop stopColor="white"/>
  <stop offset="1" stopColor="#7C7D89"/>
  </linearGradient>
  <linearGradient id="paint2_linear_275_41618" x1="18" y1="6.32812" x2="18" y2="29.6719" gradientUnits="userSpaceOnUse">
  <stop stopColor="white"/>
  <stop offset="1" stopColor="#7C7D89"/>
  </linearGradient>
  </defs>
  </svg>
);

export { Eon };

